'use client';

export { default } from './Badge';
export { default as badgeClasses } from './badgeClasses';
export * from './badgeClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Badge/index.js
// module id = 818
// module chunks = 22